import React from "react";
import { Navbar } from "@/components/Navigation/Navbar";
import { Link } from "react-router-dom";
import { ParticleBackground } from "@/components/UI/ParticleBackground";

export const MainLayout: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <div className="min-h-screen flex flex-col text-text-primary font-sans">
      <ParticleBackground />
      <div className="relative z-10 flex flex-col flex-grow">
        <Navbar />
        <main className="flex-grow container mx-auto px-4 py-12">
          {children}
        </main>

        <footer className="bg-bg-footer text-text-footer py-10">
          <div className="container mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 text-center md:text-left">
            <div className="footer-column">
              <h3 className="text-lg font-semibold text-white mb-4">
                Навигация
              </h3>
              <ul className="space-y-2">
                <li>
                  <Link
                    to="/learn"
                    className="hover:text-white transition-colors"
                  >
                    Учиться
                  </Link>
                </li>
                <li>
                  <Link to="/" className="hover:text-white transition-colors">
                    Демонстрации
                  </Link>
                </li>
                <li>
                  <Link
                    to="/glossary"
                    className="hover:text-white transition-colors"
                  >
                    Глоссарий
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about"
                    className="hover:text-white transition-colors"
                  >
                    О проекте
                  </Link>
                </li>
              </ul>
            </div>
            <div className="footer-column">
              <h3 className="text-lg font-semibold text-white mb-4">Ресурсы</h3>
              <ul className="space-y-2">
                <li>
                  <a
                    href="/assets/pdfs/Бланк.pdf"
                    target="_blank"
                    className="hover:text-white transition-colors"
                  >
                    QR-коды демонстраций
                  </a>
                </li>
                <li>
                  <a
                    href="https://github.com/ox1s/TECProject/"
                    target="_blank"
                    className="hover:text-white transition-colors"
                  >
                    GitHub репозиторий
                  </a>
                </li>
              </ul>
            </div>
            <div className="footer-column text-sm">
              <p>© 2026 Мельянцева П.Е., гр. ПО211</p>
              <p>Витебский филиал УО БГАС</p>
              <p className="mt-4 text-gray-500">
                Создано с использованием React, TypeScript и p5.js
              </p>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
};
